export const APP_NAME = 'safeHavenScorecard';
export const ANALYTICS_APP_NAME = 'safe-haven-scorecard';

export const FROM_PAGE = {
  MAIN: 'main',
};
